import { useAppStore } from 'hooks/useAppStore';

export const useUserPermission = (actions: string[] = []) => {
  const { userInfo } = useAppStore();

  const { rolesPermissions } = userInfo;

  return actions.includes('*') ? true : !!rolesPermissions && actions.some(action => rolesPermissions[action]);
};
